export default __webpack_public_path__ + "static/media/Resolucion_16_gobierno_corporativo_1.2ea07624.pdf";